/**
 * Vue bindings for Animejs
 * https://github.com/BenAHammond/vue-anime#readme
 */

import Vue from 'vue';
import VueAnime from 'vue-animejs';

Vue.use(VueAnime);
